import { inject, Injectable } from '@angular/core';
import { UserSelectors } from '@next/core-lib/user';
import { Store } from '@ngrx/store';
import { catchError, combineLatest, distinctUntilChanged, map, of, switchMap } from 'rxjs';
import { BemApiService } from 'src/app/bem/shared/services/bem-api.service';

import { BlightService } from '../../blight-v2/services/blight.service';
import { CropYearService } from './crop-year.service';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionAccessService {
  blightService = inject(BlightService);
  bemApiService = inject(BemApiService);
  cropYearService = inject(CropYearService);
  private readonly store = inject(Store);
  private readonly accessContext$ = combineLatest({
    cropYear: this.cropYearService.cropYear$,
    customerId: this.store.select(UserSelectors.selectCustomer).pipe(map((customer) => customer?.id)),
  }).pipe(
    distinctUntilChanged((previous, current) =>
      previous.customerId === current.customerId && previous.cropYear === current.cropYear),
  );

  hasAccessToBlight$ = this.accessContext$.pipe(
    switchMap(({ customerId, cropYear }) => customerId
      ? this.blightService.getCustomerBlightRights(customerId, cropYear).pipe(
        map((res) => res.isPremium),
        catchError(() => of(false)),
      )
      : of(false)),
  );

  hasAccessToBem$ = this.accessContext$.pipe(
    switchMap(({ customerId, cropYear }) => customerId
      ? this.bemApiService.isBemCustomer(cropYear).pipe(
        map((res) => res.isBemCustomer),
        catchError(() => of(false)),
      )
      : of(false)),
  );
}
